<template>
    <div id="container">
        <Spinner :show="loading"></Spinner>
        <Header></Header>
        <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
        <AccountTabs></AccountTabs>
        <section ref="content" id="content" class="section subnav no-vpadding">
            <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
            <AddTag ref="addTagModal" :_callingCode="user.callingCode.toString()" :_mobile="user.mobile"></AddTag>
            <div v-for="tag in tags" :key="tag.nfcid" class="card" :class="{blacklisted: tag.isBlacklisted}">
                <div class="card-content">
                    <template v-if="tag.isBlacklisted">
                        <h2 class="has-text-centered is-size-5">{{ $t("TagHasBeenBlacklisted") }}</h2>
                        <hr />
                    </template>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input class="input" :value="tag.nfcid" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required readonly>
                            <span class="icon is-small is-left">
                                <i class="fa fa-tag"></i>
                            </span>
                        </div>
                    </div>
                    <!-- <div v-show="(field && nfcid == tag.nfcid) || !field" class="field">
                        <div class="control has-icons-left">
                            <input class="input" @click="hideTabs(); field = true; nfcid = tag.nfcid" @focus="hideTabs(); field = true; nfcid = tag.nfcid" @blur="showTabs()" v-model="tag.name" type="text" :placeholder="$t('TagName')">
                            <span class="icon is-small is-left">
                                <i class="fa fa-tag"></i>
                            </span>
                        </div>
                    </div> -->
                    <div v-show="(field && nfcid == tag.nfcid) || !field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="tag.callingCode" @click="field = true; nfcid = tag.nfcid" @focus="field = true; nfcid = tag.nfcid">
                                        <option disabled value="disabled">{{ $t("Country") }}</option>
                                        <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                    </select>
                                </div>
                                <div class="icon is-small is-left"><i class="fa fa-globe"></i></div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input @click="hideTabs(); field = true; nfcid = tag.nfcid" @focus="hideTabs(); field = true; nfcid = tag.nfcid" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="tag.mobile" min="0">
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-phone"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('SignupDate')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.signupDate ? new Date(tag.signupDate).toLocaleDateString() : ''" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('RegisteredBy')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-user"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.createdBy ? tag.createdBy : ''" readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-user"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('LastUsage')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.lastUsage ? new Date(tag.lastUsage).toLocaleDateString() : ''" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('LastUsedTap')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="tag.lastUsedTap" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-tint"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="!field" class="columns is-mobile is-centered">
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="$t('Credits')" min="0" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-money"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="field">
                                <div class="control has-icons-left">
                                    <input class="input" type="text" :value="showCurrency(tag.credits, user.wallet.currency)" disabled readonly>
                                    <span class="icon is-small is-left">
                                        <i class="fa fa-money"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer v-show="!field">
                    <div class="columns is-mobile has-text-centered">
                        <div class="column is-half">
                            <a v-if="!tag.isBlacklisted" @click="$router.push(`/tag/topup/${tag.nfcid}`)" class="button is-primary is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-arrow-up"></i>
                                </span>
                                <span>{{ $t("Topup") }}</span>
                            </a>
                        </div>
                        <div class="column is-half">
                            <a @click="$router.push(`/tag/transactions/${tag.nfcid}`)" class="button is-info is-fullwidth">
                                <span class="icon">
                                    <i class="fa fa-history"></i>
                                </span>
                                <span>{{ $t("Transactions") }}</span>
                            </a>
                        </div>
                    </div>
                    <div v-show="tag.pendingCredits" class="columns is-mobile has-text-centered">
                        <div class="column is-full"><a @click="$router.push(`/tag/pending-credits/${tag.nfcid}`)" class="button is-success is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-money"></i>
                            </span>
                            <span>{{ $t("PendingCredits") }} ({{ tag.pendingCredits }})</span> </a></div>
                    </div>
                </footer>
            </div>
            <div v-show="!field" class="column is-full has-text-centered">
                <a @click="$refs.addTagModal.start()" class="has-text-weight-bold">
                    <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                    </span> 
                    <span>{{ $t("AddTag") }}</span>
                </a>
            </div>
            <div v-if="tags.length && field != null" class="columns is-mobile is-centered">
                <div class="column is-half has-text-centered">
                    <a @click="field = null" class="button is-info is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-times"></i>
                        </span>
                        <span>{{ $t("Cancel") }}</span>
                    </a>
                </div>
                <div class="column is-half has-text-centered">
                    <a @click="save()" class="button is-primary is-fullwidth">
                        <span class="icon">
                            <i class="fa fa-save"></i>
                        </span>
                        <span>{{ $t("SaveChanges") }}</span>
                    </a>
                </div>
            </div>
        </section>
        <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AddTag from "@/components/AddTag.vue";
import AccountTabs from "@/components/AccountTabs.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "AccountHousehold",
  components: {
    Header,
    Modal,
    AddTag,
    AccountTabs,
    Notification,
    NavigationTabs,
    Spinner
  },
  async mounted()
  {
    const response = await this.$http.get(`/Household`);
    this.tags = response.data.household.tags;
    let showModal = false;
    let body = `<p>${this.$t("PleaseCorrectBody")}</p>`;

    for(const tag of this.tags)
    {
        if(tag.name == "Unknown" || tag.name == "Offline Tag")
        {
            showModal = true;
            body += `<p>${this.$t("UnknownHousholdTagName")}</p>`;
            break;
        }
    }

    if(showModal)
    {
        this.modal.title = this.$t("UnknownTag");
        this.modal.body = body;
        this.modal.className = "is-active";
    }
  },
  data () {
    return {
        tags: [],
        field: null,
        nfcid: null,
        modal: {
            title: null,
            body: null,
            centerBody: true,
            className: "",
            buttons:
            [
                {id: 0, title: this.$t("OK"), className: "is-primary", click: () => { this.modal.className = ""; }}
            ]
        }
    }
  },
  methods:
  {
    addTag: async function(newTag)
    {
        for(const tag of this.tags)
        {
            if(tag.nfcid == newTag.nfcid)
            {
                alert(this.$t("TagAlreadyAdded"));
                return false;
            }
        }

        this.tags.push(newTag);
        await this.save();
        return true;
    },
    save: async function() {
        this.field = null;
        this.$refs.content.scrollTo(0, 0);

        try
        {
            const tags = this.tags.slice();
        
            for(const tag of tags)
            {
                tag.nfcid = tag.nfcid.toUpperCase();
            }

            const response = await this.$http.post(`/Household`,
            {
                tags: tags
            });

            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }
        }
        
        catch(error)
        {
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    }
  }
};
</script>
